import styled from 'styled-components';
export const FormAndDocContainer = styled.div `
  width: 100%;
  display: grid;
  grid-template-columns: 1fr max-content 1fr;
  gap: 20px;
`;
